import type { DamagePolygonType } from '@/common/damage-polygon';
import { axios } from '@/lib/utils/axios';
import { getResponse } from '../common';
import { API_URLS } from '../query.client';

export type UpdateDamagePolygonSuccessResponseType = DamagePolygonType;

export async function updateDamagePolygon(
	polygonId: string,
	payload: Partial<Omit<DamagePolygonType, 'id'>>
): Promise<UpdateDamagePolygonSuccessResponseType | null> {
	//PATCH /api/polygons/:id
	const response = await axios.patch(`${API_URLS.DAMAGE_POLYGONS.INDEX}/${polygonId}`, payload);

	return getResponse<UpdateDamagePolygonSuccessResponseType>(response.data);
}
